import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { useAuth } from 'contexts/AuthContext';
import { useApiKey } from 'contexts/ApiKeyContext';
import s from './McpPage.module.css';

const MCP_URL = 'https://quadratikmcp-production.up.railway.app';

function buildConfig(apiKey) {
    return `{
  "mcpServers": {
    "quadratik": {
      "url": "${MCP_URL}",
      "headers": {
        "X-API-Key": "${apiKey || '<YOUR_API_KEY>'}"
      }
    }
  }
}`;
}

const CLIENTS = [
    { id: 'claude', label: 'Claude Desktop', file: 'claude_desktop_config.json' },
    { id: 'cursor', label: 'Cursor', file: '.cursor/mcp.json' },
    { id: 'claude-code', label: 'Claude Code', file: '~/.claude.json' },
];

const McpPage = () => {
    const { user, loading } = useAuth();
    const { plaintextKey, hasKey } = useApiKey();
    const history = useHistory();
    const [active, setActive] = useState('claude');
    const [copied, setCopied] = useState(false);

    useEffect(() => {
        if (!loading && !user) {
            history.replace('/loginsignup');
        }
    }, [loading, user, history]);

    if (loading) {
        return (
            <div className={s.McpPage}>
                <div className={s.inner}>Loading...</div>
            </div>
        );
    }

    if (!user) return null;

    const current = CLIENTS.find((c) => c.id === active);
    const config = buildConfig(plaintextKey);

    const handleCopy = () => {
        navigator.clipboard.writeText(config);
        setCopied(true);
        setTimeout(() => setCopied(false), 2000);
    };

    let statusMessage;
    if (plaintextKey) {
        statusMessage = ' Your API key has been pre-filled.';
    } else if (hasKey) {
        statusMessage = (
            <> Your existing key can't be displayed (only the hash is stored). <span className={s.link} onClick={() => history.push('/api')}>Rotate it on the API page</span> to get a fresh key, then return here to copy the config.</>
        );
    } else {
        statusMessage = (
            <> You don't have an API key yet — <span className={s.link} onClick={() => history.push('/api')}>create one</span> to get full access.</>
        );
    }

    return (
        <div className={s.McpPage}>
            <div className={s.inner}>
                <img src="/logo.png" alt="Company logo" className={s.logo} />
                <h1 className={s.header}>MCP</h1>
                <p className={s.subHeader}>Connect in under a minute.</p>
                <p className={s.description}>
                    Copy the config below into your client's MCP settings file.
                    {statusMessage}
                    {' '}Searching works without a key — results will have masked emails and phones.
                </p>

                <div className={s.tabs}>
                    {CLIENTS.map(({ id, label }) => (
                        <button
                            key={id}
                            onClick={() => { setActive(id); setCopied(false); }}
                            className={`${s.tab} ${active === id ? s.tabActive : ''}`}
                        >
                            {label}
                        </button>
                    ))}
                </div>

                <div className={s.configCard}>
                    <div className={s.configHeader}>
                        <span className={s.fileName}>{current.file}</span>
                        <button onClick={handleCopy} className={s.copyBtn}>
                            {copied ? 'Copied' : 'Copy'}
                        </button>
                    </div>
                    <pre className={s.configPre}>{config}</pre>
                </div>
            </div>
        </div>
    );
};

export default McpPage;
